import PlantTechicalView from './PlantTechicalView';

export default PlantTechicalView;
